import { Game } from './game.js';
import { Renderer } from './renderer.js';
import { InputHandler } from './input.js';
import { AudioEngine } from './audio.js';

// Game state
let game = null;
let renderer = null;
let inputHandler = null;
let audioEngine = null;

// Canvas setup
const canvas = document.getElementById('game-canvas');
const ctx = canvas.getContext('2d');

// Resize canvas to fill available space
function resizeCanvas() {
  canvas.width = canvas.offsetWidth;
  canvas.height = canvas.offsetHeight;
}

window.addEventListener('resize', resizeCanvas);
resizeCanvas();

// Game loop
let lastTime = 0;

function gameLoop(timestamp) {
  const deltaTime = timestamp - lastTime;
  lastTime = timestamp;

  // Update game state
  if (game && game.isRunning) {
    game.update(deltaTime);

    // Update audio
    if (audioEngine) {
      audioEngine.update(game.state);
    }
  }

  // Render
  if (renderer && game) {
    renderer.clear();
    renderer.render(game.state);
  }

  requestAnimationFrame(gameLoop);
}

// UI Elements
const startButton = document.getElementById('start-button');
const restartButton = document.getElementById('restart-button');
const startOverlay = document.getElementById('start-overlay');
const gameoverOverlay = document.getElementById('gameover-overlay');
const scoreDisplay = document.getElementById('score');
const waveDisplay = document.getElementById('wave');
const livesDisplay = document.getElementById('lives');
const finalScoreDisplay = document.getElementById('final-score');
const frequencyDisplay = document.getElementById('frequency-display');

// Start game
async function startGame() {
  console.log('Starting game...');

  // Hide start overlay
  startOverlay.classList.add('hidden');

  // Initialize audio engine
  if (!audioEngine) {
    audioEngine = new AudioEngine();
    await audioEngine.init();
    console.log('Audio engine ready');
  }

  // Initialize game
  game = new Game(canvas.width, canvas.height);

  // Initialize renderer
  renderer = new Renderer(ctx, canvas.width, canvas.height);

  // Initialize input handler
  inputHandler = new InputHandler(
    document.getElementById('dial'),
    (frequency) => {
      if (game) {
        game.setPlayerFrequency(frequency);
        frequencyDisplay.textContent = `${Math.round(frequency)} Hz`;
      }
      if (audioEngine) {
        audioEngine.setPlayerFrequency(frequency);
      }
    }
  );

  // Game event listeners
  game.on('scoreChange', (score) => {
    scoreDisplay.textContent = `SCORE: ${score}`;
  });

  game.on('waveChange', (wave) => {
    waveDisplay.textContent = `WAVE: ${wave}`;
  });

  game.on('livesChange', (lives) => {
    livesDisplay.textContent = `LIVES: ${'█'.repeat(lives)}`;
  });

  game.on('gameOver', (finalScore) => {
    finalScoreDisplay.textContent = `SCORE: ${finalScore}`;
    gameoverOverlay.classList.remove('hidden');

    // Stop audio
    if (audioEngine) {
      audioEngine.stopAll();
    }
  });

  game.on('monsterSpawn', (monster) => {
    if (audioEngine) {
      audioEngine.spawnMonsterOscillator(monster);
    }
  });

  game.on('monsterKill', (monster) => {
    if (audioEngine) {
      audioEngine.killMonster(monster);
    }
  });

  game.start();
}

// Restart game
function restartGame() {
  gameoverOverlay.classList.add('hidden');
  startGame();
}

// Event listeners
startButton.addEventListener('click', startGame);
restartButton.addEventListener('click', restartGame);

// Start animation loop
requestAnimationFrame(gameLoop);
